export default __webpack_public_path__ + "dc98e2076170375f4df3efd03905d4ee.svg";